import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const JournalEntryFilters = ({
  searchTerm,
  onSearchChange,
  statusFilter,
  onStatusChange,
  dateRange,
  onDateRangeChange
}) => {
  const statusOptions = [
    { value: 'all', label: 'All Statuses' },
    { value: 'Posted', label: 'Posted' },
    { value: 'Draft', label: 'Draft' },
    { value: 'Pending Approval', label: 'Pending Approval' },
    { value: 'Reversed', label: 'Reversed' }
  ];

  const dateRangeOptions = [
    { value: 'all', label: 'All Time' },
    { value: 'today', label: 'Today' },
    { value: 'week', label: 'Last 7 Days' },
    { value: 'month', label: 'Last 30 Days' },
    { value: 'quarter', label: 'Last 90 Days' }
  ];

  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="relative">
          <Icon
            name="Search"
            size={18}
            className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"
          />
          <Input
            placeholder="Search entries..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="pl-10"
          />
        </div>

        <Select
          options={statusOptions}
          value={statusFilter}
          onChange={onStatusChange}
          placeholder="Filter by status"
        />

        <Select
          options={dateRangeOptions}
          value={dateRange}
          onChange={onDateRangeChange}
          placeholder="Filter by date"
        />
      </div>
    </div>
  );
};

export default JournalEntryFilters;